const CloudUploadIcon = ({ fill = '#626679' }: { fill: string }) => {
  return (
    <svg
      id="MDI_cloud-upload-outline"
      data-name="MDI / cloud-upload-outline"
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48">
      <g id="Boundary" transform="translate(0)" fill={fill} stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
        <rect width="48" height="48" stroke="none" />
        <rect x="0.5" y="0.5" width="47" height="47" fill="none" />
      </g>
      <path
        id="Path_cloud-upload-outline"
        data-name="Path / cloud-upload-outline"
        d="M38.7,16.08a14.985,14.985,0,0,0-28-4A11.995,11.995,0,0,0,12,36H38a9.971,9.971,0,0,0,.7-19.92M38,32H12a7.994,7.994,0,0,1-.88-15.94l2.14-.22,1-1.9a10.974,10.974,0,0,1,20.52,2.92l.6,3,3.06.22A5.967,5.967,0,0,1,38,32M16,22h5.1v6h5.8V22H32l-8-8Z"
        transform="translate(0 3.928)"
        fill={fill}
      />
    </svg>
  );
};

export default CloudUploadIcon;
